// DOMが読み込まれた後に実行
document.addEventListener('DOMContentLoaded', function() {
  
  // デスクトップ用: 月の切り替え
  window.showMonth = function(monthId) {
    // すべてのカレンダーを非表示
    var calendars = document.querySelectorAll('.calendar-month');
    calendars.forEach(function(calendar) {
      calendar.classList.remove('active');
    });
    
    // すべてのタブを非アクティブに
    var tabs = document.querySelectorAll('.calendar-tab');
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
    });
    
    // 選択された月を表示
    var selectedCalendar = document.getElementById('calendar-' + monthId);
    if (selectedCalendar) {
      selectedCalendar.classList.add('active');
    }
    
    // クリックされたタブをアクティブに
    if (event && event.target) {
      event.target.classList.add('active');
    }
  };
  
  // モバイル用: 月の開閉トグル
  window.toggleMonth = function(monthId) {
    const monthList = document.getElementById(monthId);
    const button = event.currentTarget;
    const arrow = button.querySelector('.toggle-arrow');
    
    if (!monthList || !button) return;
    
    // 表示/非表示の切り替え
    if (monthList.classList.contains('active')) {
      monthList.classList.remove('active');
      button.classList.remove('active');
      if (arrow) arrow.textContent = '▼';
    } else {
      monthList.classList.add('active');
      button.classList.add('active');
      if (arrow) arrow.textContent = '▲';
    }
  };
  
});
